
[
	{
		"label": "KiloPascals  (kPa)",
		"value": "kPa",
		"bacnet_unit": "UNIT_KILOPASCALS"
	},
	{
		"label": "Weeks (weeks)",
		"value": "weeks",
		"bacnet_unit": "UNIT_WEEKS"
	},
	{
		"label": "Volt-Ampere Reactive  (VAR)",
		"value": "VAR",
		"bacnet_unit": "UNIT_WATT_HOURS_REACTIVE"
	},
	{
		"label": "Pascal  (Pa)",
		"value": "Pa",
		"bacnet_unit": "UNIT_PASCALS"
	},
	{
		"label": "Joules Per Kg Degree K (J/kg-K)",
		"value": "J/kg-K",
		"bacnet_unit": "UNIT_JOULES_PER_KG_DEGREE_K"
	},
	{
		"label": "Centimeters of water (cmH₂O)",
		"value": "cmH₂O",
		"bacnet_unit": "UNIT_CENTIMETERS_OF_WATER"
	},
	{
		"label": "Candelas per square meter (cd/m²)",
		"value": "cd/m²",
		"bacnet_unit": "UNIT_CANDELAS_PER_SQUARE_METER"
	},
	{
		"label": "Kilo Amperes  (kA)",
		"value": "kA",
		"bacnet_unit": null
	},
	{
		"label": "Millimeters Of Mercury (mmHg)",
		"value": "mmHg",
		"bacnet_unit": "UNIT_MILLIMETERS_OF_MERCURY"
	},
	{
		"label": "Miles Per Hour (mi/h)",
		"value": "mi/h",
		"bacnet_unit": "UNIT_MILES_PER_HOUR"
	},
	{
		"label": "Kilojoules (kJ)",
		"value": "kJ",
		"bacnet_unit": "UNIT_KILOJOULES"
	},
	{
		"label": "Sq Centimeters (cm²)",
		"value": "cm²",
		"bacnet_unit": "UNIT_SQ_CENTIMETERS"
	},
	{
		"label": "Newton Seconds (Ns)",
		"value": "Ns",
		"bacnet_unit": "UNIT_NEWTON_SECONDS"
	},
	{
		"label": "Kilograms (kg)",
		"value": "kg",
		"bacnet_unit": "UNIT_KILOGRAMS"
	},
	{
		"label": "Kilograms Per Kilogram (kg/kg)",
		"value": "kg/kg",
		"bacnet_unit": "UNIT_KILOGRAMS_PER_KILOGRAM"
	},
	{
		"label": "Micrometers (µm)",
		"value": "µm",
		"bacnet_unit": "UNIT_MICROMETERS"
	},
	{
		"label": "Degree Days F (°F degree day)",
		"value": "°F degree day",
		"bacnet_unit": "UNIT_DEGREE_DAYS_F"
	},
	{
		"label": "Kilometers Per Hour (km/h)",
		"value": "km/h",
		"bacnet_unit": "UNIT_KILOMETERS_PER_HOUR"
	},
	{
		"label": "Milliliters (ml)",
		"value": "ml",
		"bacnet_unit": "UNIT_MILLILITERS"
	},
	{
		"label": "Kilo Volts  (kV)",
		"value": "kV",
		"bacnet_unit": "UNIT_KILOVOLTS"
	},
	{
		"label": "Megajoules Per Sq Foot (MJ/ft²)",
		"value": "MJ/ft²",
		"bacnet_unit": "UNIT_MEGAJOULES_PER_SQ_FOOT"
	},
	{
		"label": "Kilo Volt-Ampere Reactive  (kVAR)",
		"value": "kVAR",
		"bacnet_unit": "UNIT_KILOVOLT_AMPERES_REACTIVE"
	},
	{
		"label": "BTUs per hour (btus/hour)",
		"value": "btus/hour",
		"bacnet_unit": "UNIT_BTUS_PER_HOUR"
	},
	{
		"label": "Grams Per Milliliter (g/ml)",
		"value": "g/ml",
		"bacnet_unit": "UNIT_GRAMS_PER_MILLILITER"
	},
	{
		"label": "Horsepower (hp)",
		"value": "hp",
		"bacnet_unit": "UNIT_HORSEPOWER"
	},
	{
		"label": "Kgs Per Minute (kg/min)",
		"value": "kg/min",
		"bacnet_unit": "UNIT_KGS_PER_MINUTE"
	},
	{
		"label": "Kwatt Hours Per Sq Foot (kWh/ft²)",
		"value": "kWh/ft²",
		"bacnet_unit": "UNIT_KWATT_HOURS_PER_SQ_FOOT"
	},
	{
		"label": "Pounds  (lbs)",
		"value": "lbs",
		"bacnet_unit": "UNIT_POUNDS_MASS"
	},
	{
		"label": "Megabecquerels (MBq)",
		"value": "MBq",
		"bacnet_unit": "UNIT_MEGABECQUERELS"
	},
	{
		"label": "Pound/hour  (lb/h)",
		"value": "lb/h",
		"bacnet_unit": "UNIT_LBS_MASS_PER_HOUR"
	},
	{
		"label": "Imp Gallons Per Minute (Imp. gal/min)",
		"value": "Imp. gal/min",
		"bacnet_unit": "UNIT_IMP_GALLONS_PER_MINUTE"
	},
	{
		"label": "Milliohms (mΩ)",
		"value": "mΩ",
		"bacnet_unit": "UNIT_MILLIOHMS"
	},
	{
		"label": "Imperial Gallons (Imp. gal)",
		"value": "Imp. gal",
		"bacnet_unit": "UNIT_IMPERIAL_GALLONS"
	},
	{
		"label": "Micrograms Per Cubic Meter (µg/m³)",
		"value": "µg/m³",
		"bacnet_unit": "UNIT_MICROGRAMS_PER_CUBIC_METER"
	},
	{
		"label": "Millisieverts (mSv)",
		"value": "mSv",
		"bacnet_unit": "UNIT_MILLISIEVERTS"
	},
	{
		"label": "Radians (rad)",
		"value": "rad",
		"bacnet_unit": "UNIT_RADIANS"
	},
	{
		"label": "Degrees C Per Hour (°C/h)",
		"value": "°C/h",
		"bacnet_unit": "UNIT_DEGREES_C_PER_HOUR"
	},
	{
		"label": "Kgs Per Second (kg/s)",
		"value": "kg/s",
		"bacnet_unit": "UNIT_KGS_PER_SECOND"
	},
	{
		"label": "Decibels Millivolt (dBmV)",
		"value": "dBmV",
		"bacnet_unit": "UNIT_DECIBELS_MILLIVOLT"
	},
	{
		"label": "Cycles Per Minute (cycles/minute)",
		"value": "cycles/minute",
		"bacnet_unit": "UNIT_CYCLES_PER_MINUTE"
	},
	{
		"label": "Kilo Volt-Ampere Hours  (kVAH)",
		"value": "kVAH",
		"bacnet_unit": null
	},
	{
		"label": "Microgray (µGy)",
		"value": "µGy",
		"bacnet_unit": "UNIT_MICROGRAY"
	},
	{
		"label": "Ph (Ph)",
		"value": "Ph",
		"bacnet_unit": "UNIT_PH"
	},
	{
		"label": "Per Minute (/min)",
		"value": "/min",
		"bacnet_unit": "UNIT_PER_MINUTE"
	},
	{
		"label": "Mega Volts  (MV)",
		"value": "MV",
		"bacnet_unit": "UNIT_MEGAVOLTS"
	},
	{
		"label": "Microsieverts (µSv)",
		"value": "µSv",
		"bacnet_unit": "UNIT_MICROSIEVERTS"
	},
	{
		"label": "Gallons/minute  (gal/min)",
		"value": "gal/min",
		"bacnet_unit": "UNIT_US_GALLONS_PER_MINUTE"
	},
	{
		"label": "BTUs per pound (buts/poud)",
		"value": "buts/poud",
		"bacnet_unit": "UNIT_BTUS_PER_POUND"
	},
	{
		"label": "Giga Volt-Ampere Hours  (GVAH)",
		"value": "GVAH",
		"bacnet_unit": null
	},
	{
		"label": "Micrograms Per Liter (µg/L)",
		"value": "µg/L",
		"bacnet_unit": "UNIT_MICROGRAMS_PER_LITER"
	},
	{
		"label": "Seconds  (s)",
		"value": "s",
		"bacnet_unit": "UNIT_SECONDS"
	},
	{
		"label": "Newton per square meter  (N/m²)",
		"value": "N/m²",
		"bacnet_unit": null
	},
	{
		"label": "Centimeters of mercury (cmHg)",
		"value": "cmHg",
		"bacnet_unit": "UNIT_CENTIMETERS_OF_MERCURY"
	},
	{
		"label": "Degrees Kelvin Per Minute (K/min)",
		"value": "K/min",
		"bacnet_unit": "UNIT_DEGREES_KELVIN_PER_MINUTE"
	},
	{
		"label": "Degrees K (K)",
		"value": "K",
		"bacnet_unit": "UNIT_DEGREES_K"
	},
	{
		"label": "Inches Of Water (inH₂O)",
		"value": "inH₂O",
		"bacnet_unit": "UNIT_INCHES_OF_WATER"
	},
	{
		"label": "Delta Degrees Fahrenheit (Δ°F)",
		"value": "Δ°F",
		"bacnet_unit": "UNIT_DELTA_DEGREES_FAHRENHEIT"
	},
	{
		"label": "Percent Per Second (%/s)",
		"value": "%/s",
		"bacnet_unit": "UNIT_PERCENT_PER_SECOND"
	},
	{
		"label": "Ohms (Ω)",
		"value": "Ω",
		"bacnet_unit": "UNIT_OHMS"
	},
	{
		"label": "Watt  (W)",
		"value": "W",
		"bacnet_unit": "UNIT_WATTS"
	},
	{
		"label": "Milligray (mGy)",
		"value": "mGy",
		"bacnet_unit": "UNIT_MILLIGRAY"
	},
	{
		"label": "Tons (ton)",
		"value": "ton",
		"bacnet_unit": "UNIT_TONS"
	},
	{
		"label": "GigaWatt-Hour  (GWH)",
		"value": "GWH",
		"bacnet_unit": null
	},
	{
		"label": "Pound-Force per square inch  (Psi)",
		"value": "Psi",
		"bacnet_unit": null
	},
	{
		"label": "BTUs (btus)",
		"value": "btus",
		"bacnet_unit": "UNIT_BTUS"
	},
	{
		"label": "Ampère per Meter (A/m)",
		"value": "A/m",
		"bacnet_unit": "UNIT_AMPERES_PER_METER"
	},
	{
		"label": "Kilogram-force per centimetre square  (kgf/cm²)",
		"value": "kgf/cm²",
		"bacnet_unit": null
	},
	{
		"label": "Ampère Square Meters (Am²)",
		"value": "Am²",
		"bacnet_unit": "UNIT_AMPERE_SQUARE_METERS"
	},
	{
		"label": "Centimeters (cm)",
		"value": "cm",
		"bacnet_unit": "UNIT_CENTIMETERS"
	},
	{
		"label": "Liters Per Second (L/s)",
		"value": "L/s",
		"bacnet_unit": "UNIT_LITERS_PER_SECOND"
	},
	{
		"label": "Milligrams Per Liter (mg/L)",
		"value": "mg/L",
		"bacnet_unit": "UNIT_MILLIGRAMS_PER_LITER"
	},
	{
		"label": "Kilojoules Per Degree K (kJ/K)",
		"value": "kJ/K",
		"bacnet_unit": "UNIT_KILOJOULES_PER_DEGREE_K"
	},
	{
		"label": "Kgs Per Hour (kg/hour)",
		"value": "kg/hour",
		"bacnet_unit": "UNIT_KGS_PER_HOUR"
	},
	{
		"label": "Becquerels (Bq)",
		"value": "Bq",
		"bacnet_unit": "UNIT_BECQUERELS"
	},
	{
		"label": "Meters Per Second Per Second (m/s/s)",
		"value": "m/s/s",
		"bacnet_unit": "UNIT_METERS_PER_SECOND_PER_SECOND"
	},
	{
		"label": "Teslas (T)",
		"value": "T",
		"bacnet_unit": "UNIT_TESLAS"
	},
	{
		"label": "Kilojoules Per Kg (kJ/kg)",
		"value": "kJ/kg",
		"bacnet_unit": "UNIT_KILOJOULES_PER_KG"
	},
	{
		"label": "Mega Volt-Amperes  (MVA)",
		"value": "MVA",
		"bacnet_unit": "UNIT_MEGAVOLT_AMPERES"
	},
	{
		"label": "Grams Per Liter (g/l)",
		"value": "g/l",
		"bacnet_unit": "UNIT_GRAMS_PER_LITER"
	},
	{
		"label": "Megajoules Per Sq Meter (MJ/m²)",
		"value": "MJ/m²",
		"bacnet_unit": "UNIT_MEGAJOULES_PER_SQ_METER"
	},
	{
		"label": "meters/sec  (m/sec)",
		"value": "m/sec",
		"bacnet_unit": "UNIT_METERS_PER_SECOND"
	},
	{
		"label": "Meters (m)",
		"value": "m",
		"bacnet_unit": "UNIT_METERS"
	},
	{
		"label": "Farads (F)",
		"value": "F",
		"bacnet_unit": "UNIT_FARADS"
	},
	{
		"label": "Kilo Volt-Amperes  (kVA)",
		"value": "kVA",
		"bacnet_unit": "UNIT_KILOVOLT_AMPERES"
	},
	{
		"label": "Lbs Force Per Sq Inch (lbf/in²)",
		"value": "lbf/in²",
		"bacnet_unit": "UNIT_LBS_FORCE_PER_SQ_INCH"
	},
	{
		"label": "Degrees F Per Minute (°F/min)",
		"value": "°F/min",
		"bacnet_unit": "UNIT_DEGREES_F_PER_MINUTE"
	},
	{
		"label": "Millivolt  (mV)",
		"value": "mV",
		"bacnet_unit": "UNIT_MILLIVOLTS"
	},
	{
		"label": "Hectopascals (hPa)",
		"value": "hPa",
		"bacnet_unit": "UNIT_HECTOPASCALS"
	},
	{
		"label": "inches  (in)",
		"value": "in",
		"bacnet_unit": "UNIT_INCHES"
	},
	{
		"label": "Millimeter  (mm)",
		"value": "mm",
		"bacnet_unit": "UNIT_MILLIMETERS"
	},
	{
		"label": "Joule Seconds (J s)",
		"value": "J s",
		"bacnet_unit": "UNIT_JOULE_SECONDS"
	},
	{
		"label": "Volt Amperes Reactive (VA R)",
		"value": "VA R",
		"bacnet_unit": "UNIT_VOLT_AMPERES_REACTIVE"
	},
	{
		"label": "Megohms (MΩ)",
		"value": "MΩ",
		"bacnet_unit": "UNIT_MEGOHMS"
	},
	{
		"label": "Psi Per Degree F (psi/°F)",
		"value": "psi/°F",
		"bacnet_unit": "UNIT_PSI_PER_DEGREE_F"
	},
	{
		"label": "Watts Per Sq M Degree K (W/m² K)",
		"value": "W/m² K",
		"bacnet_unit": "UNIT_WATTS_PER_SQ_M_DEGREE_K"
	},
	{
		"label": "Square Meters Per Newton (m²/N)",
		"value": "m²/N",
		"bacnet_unit": "UNIT_SQUARE_METERS_PER_NEWTON"
	},
	{
		"label": "Milligrams Per Kilogram (mg/kg)",
		"value": "mg/kg",
		"bacnet_unit": "UNIT_MILLIGRAMS_PER_KILOGRAM"
	},
	{
		"label": "Kilograms Per Cubic Meter (kg/m³)",
		"value": "kg/m³",
		"bacnet_unit": "UNIT_KILOGRAMS_PER_CUBIC_METER"
	},
	{
		"label": "Feet Per Minute (ft/min)",
		"value": "ft/min",
		"bacnet_unit": "UNIT_FEET_PER_MINUTE"
	},
	{
		"label": "Lumens (lm)",
		"value": "lm",
		"bacnet_unit": "UNIT_LUMENS"
	},
	{
		"label": "Cubic feet/min  (cfm)",
		"value": "cfm",
		"bacnet_unit": "UNIT_CUBIC_FEET_PER_MINUTE"
	},
	{
		"label": "Kilo Btus Per Hour (kBTU/hour)",
		"value": "kBTU/hour",
		"bacnet_unit": "UNIT_KILO_BTUS_PER_HOUR"
	},
	{
		"label": "Volt-Ampere Hours  (VAH)",
		"value": "VAH",
		"bacnet_unit": null
	},
	{
		"label": "Grams Per Cubic Centimeter (g/cm³)",
		"value": "g/cm³",
		"bacnet_unit": "UNIT_GRAMS_PER_CUBIC_CENTIMETER"
	},
	{
		"label": "Milliwatts (mW)",
		"value": "mW",
		"bacnet_unit": "UNIT_MILLIWATTS"
	},
	{
		"label": "Mega Volt-Ampere Reactive  (MVAR)",
		"value": "MVAR",
		"bacnet_unit": "UNIT_MEGAVOLT_AMPERES_REACTIVE"
	},
	{
		"label": "Mega Volt-Ampere Hours  (MVAH)",
		"value": "MVAH",
		"bacnet_unit": null
	},
	{
		"label": "Kilometers (km)",
		"value": "km",
		"bacnet_unit": "UNIT_KILOMETERS"
	},
	{
		"label": "Volts  (V)",
		"value": "V",
		"bacnet_unit": "UNIT_VOLTS"
	},
	{
		"label": "Megawatt-hour  (MWh)",
		"value": "MWh",
		"bacnet_unit": "UNIT_MEGAWATT_HOURS"
	},
	{
		"label": "Cubic Feet Per Second (ft³/s)",
		"value": "ft³/s",
		"bacnet_unit": "UNIT_CUBIC_FEET_PER_SECOND"
	},
	{
		"label": "Feet (ft)",
		"value": "ft",
		"bacnet_unit": "UNIT_FEET"
	},
	{
		"label": "Tons Refrigeration (TR)",
		"value": "TR",
		"bacnet_unit": "UNIT_TONS_REFRIGERATION"
	},
	{
		"label": "Force  (F)",
		"value": "F",
		"bacnet_unit": null
	},
	{
		"label": "Grams Per Gram (g/g)",
		"value": "g/g",
		"bacnet_unit": "UNIT_GRAMS_PER_GRAM"
	},
	{
		"label": "Gallons  (gal)",
		"value": "gal",
		"bacnet_unit": null
	},
	{
		"label": "Liters  (l)",
		"value": "l",
		"bacnet_unit": "UNIT_LITERS"
	},
	{
		"label": "Hours  (h)",
		"value": "h",
		"bacnet_unit": "UNIT_HOURS"
	},
	{
		"label": "Degrees F Per Hour (°F/h)",
		"value": "°F/h",
		"bacnet_unit": "UNIT_DEGREES_F_PER_HOUR"
	},
	{
		"label": "Ampère  (A)",
		"value": "A",
		"bacnet_unit": "UNIT_AMPERES"
	},
	{
		"label": "Watt-hours  (Wh)",
		"value": "Wh",
		"bacnet_unit": "UNIT_WATT_HOURS"
	},
	{
		"label": "Percentage of relative humidity  (%RH)",
		"value": "%RH",
		"bacnet_unit": "UNIT_RELATIVE_HUMIDITY"
	},
	{
		"label": "Cubic feet per hour (ft³/h)",
		"value": "ft³/h",
		"bacnet_unit": "UNIT_CUBIC_FEET_PER_HOUR"
	},
	{
		"label": "Lbs Mass Per Second (lb/s)",
		"value": "lb/s",
		"bacnet_unit": "UNIT_LBS_MASS_PER_SECOND"
	},
	{
		"label": "Kwatt Hours Per Sq Meter (kWh/m²)",
		"value": "kWh/m²",
		"bacnet_unit": "UNIT_KWATT_HOURS_PER_SQ_METER"
	},
	{
		"label": "Parts Per Billion (ppb)",
		"value": "ppb",
		"bacnet_unit": "UNIT_PARTS_PER_BILLION"
	},
	{
		"label": "Minutes  (min)",
		"value": "min",
		"bacnet_unit": "UNIT_MINUTES"
	},
	{
		"label": "Milliseconds  (ms)",
		"value": "ms",
		"bacnet_unit": "UNIT_MILLISECONDS"
	},
	{
		"label": "Megahertz (MHz)",
		"value": "MHz",
		"bacnet_unit": "UNIT_MEGAHERTZ"
	},
	{
		"label": "Microvolt  (µV)",
		"value": "µV",
		"bacnet_unit": null
	},
	{
		"label": "Decibels (dB)",
		"value": "dB",
		"bacnet_unit": "UNIT_DECIBELS"
	},
	{
		"label": "Kilobecquerels (kBq)",
		"value": "kBq",
		"bacnet_unit": "UNIT_KILOBECQUERELS"
	},
	{
		"label": "Hertz  (Hz)",
		"value": "Hz",
		"bacnet_unit": "UNIT_HERTZ"
	},
	{
		"label": "Degree Days C (°C degree day)",
		"value": "°C degree day",
		"bacnet_unit": "UNIT_DEGREE_DAYS_C"
	},
	{
		"label": "Volt-Amperes  (VA)",
		"value": "VA",
		"bacnet_unit": "UNIT_VOLT_AMPERES"
	},
	{
		"label": "Radians Per Second (rad/s)",
		"value": "rad/s",
		"bacnet_unit": "UNIT_RADIANS_PER_SECOND"
	},
	{
		"label": "Minutes Per Degree Kelvin (min/K)",
		"value": "min/K",
		"bacnet_unit": "UNIT_MINUTES_PER_DEGREE_KELVIN"
	},
	{
		"label": "Mega Btus (MBTUs)",
		"value": "MBTUs",
		"bacnet_unit": "UNIT_MEGA_BTUS"
	},
	{
		"label": "Volts Per Degree Kelvin (V/K)",
		"value": "V/K",
		"bacnet_unit": "UNIT_VOLTS_PER_DEGREE_KELVIN"
	},
	{
		"label": "Grams Of Water Per Kg (g wt/Kg)",
		"value": "g wt/Kg",
		"bacnet_unit": "UNIT_GRAMS_OF_WATER_PER_KG"
	},
	{
		"label": "Liters/min  (l/min)",
		"value": "l/min",
		"bacnet_unit": "UNIT_LITERS_PER_MINUTE"
	},
	{
		"label": "Delta Degrees Kelvin (ΔK)",
		"value": "ΔK",
		"bacnet_unit": "UNIT_DELTA_DEGREES_KELVIN"
	},
	{
		"label": "inch of Mercury  (in. Hg)",
		"value": "in. Hg",
		"bacnet_unit": "UNIT_INCHES_OF_MERCURY"
	},
	{
		"label": "Megawatt Hours Reactive (MW/hR)",
		"value": "MW/hR",
		"bacnet_unit": "UNIT_MEGAWATT_HOURS_REACTIVE"
	},
	{
		"label": "Humidity  (%)",
		"value": "%",
		"bacnet_unit": "UNIT_PERCENT"
	},
	{
		"label": "Temperature in Farenheit  (°F)",
		"value": "°F",
		"bacnet_unit": "UNIT_DEGREES_F"
	},
	{
		"label": "Percent  (%)",
		"value": "%",
		"bacnet_unit": "UNIT_PERCENT"
	},
	{
		"label": "Bar  (bar)",
		"value": "bar",
		"bacnet_unit": "UNIT_BARS"
	},
	{
		"label": "Revolutions/min  (RPM)",
		"value": "RPM",
		"bacnet_unit": "UNIT_REVOLUTIONS_PER_MIN"
	},
	{
		"label": "Parts Per Million (ppm)",
		"value": "ppm",
		"bacnet_unit": "UNIT_PARTS_PER_MILLION"
	},
	{
		"label": "Microsieverts Per Hour (µSv/h)",
		"value": "µSv/h",
		"bacnet_unit": "UNIT_MICROSIEVERTS_PER_HOUR"
	},
	{
		"label": "Newton Meters (Nm)",
		"value": "Nm",
		"bacnet_unit": "UNIT_NEWTON_METERS"
	},
	{
		"label": "Degrees C Per Minute (°C/min)",
		"value": "°C/min",
		"bacnet_unit": "UNIT_DEGREES_C_PER_MINUTE"
	},
	{
		"label": "Grams (g)",
		"value": "g",
		"bacnet_unit": "UNIT_GRAMS"
	},
	{
		"label": "Ton Hours (ton-hours)",
		"value": "ton-hours",
		"bacnet_unit": "UNIT_TON_HOURS"
	},
	{
		"label": "Kilogram/hour  (kg/hr)",
		"value": "kg/hr",
		"bacnet_unit": null
	},
	{
		"label": "Newtons Per Meter (N/m)",
		"value": "N/m",
		"bacnet_unit": "UNIT_NEWTONS_PER_METER"
	},
	{
		"label": "Megajoules Per Degree K (MJ/K)",
		"value": "MJ/K",
		"bacnet_unit": "UNIT_MEGAJOULES_PER_DEGREE_K"
	},
	{
		"label": "Cubic feet (ft³)",
		"value": "ft³",
		"bacnet_unit": "UNIT_CUBIC_FEET"
	},
	{
		"label": "Ohm Meters (Ωm)",
		"value": "Ωm",
		"bacnet_unit": "UNIT_OHM_METERS"
	},
	{
		"label": "Milliliters Per Second (ml/s)",
		"value": "ml/s",
		"bacnet_unit": "UNIT_MILLILITERS_PER_SECOND"
	},
	{
		"label": "Kilo Btus (kBTU)",
		"value": "kBTU",
		"bacnet_unit": "UNIT_KILO_BTUS"
	},
	{
		"label": "Milliampère  (mA)",
		"value": "mA",
		"bacnet_unit": "UNIT_MILLIAMPERES"
	},
	{
		"label": "Therms (thm)",
		"value": "thm",
		"bacnet_unit": "UNIT_THERMS"
	},
	{
		"label": "Sq Meters (m²)",
		"value": "m²",
		"bacnet_unit": "UNIT_SQ_METERS"
	},
	{
		"label": "Days (days)",
		"value": "days",
		"bacnet_unit": "UNIT_DAYS"
	},
	{
		"label": "Kilogram per centimetre square  (kg/cm²)",
		"value": "kg/cm²",
		"bacnet_unit": null
	},
	{
		"label": "Webers (Wb)",
		"value": "Wb",
		"bacnet_unit": "UNIT_WEBERS"
	},
	{
		"label": "Millibar  (millibar)",
		"value": "millibar",
		"bacnet_unit": "UNIT_MILLIBARS"
	},
	{
		"label": "Millimeters Of Water (mlH₂O)",
		"value": "mlH₂O",
		"bacnet_unit": "UNIT_MILLIMETERS_OF_WATER"
	},
	{
		"label": "Nephelometric Turbidity Unit (NTU)",
		"value": "NTU",
		"bacnet_unit": "UNIT_NEPHELOMETRIC_TURBIDITY_UNIT"
	},
	{
		"label": "Watt per square meter  (W/m²)",
		"value": "W/m²",
		"bacnet_unit": "UNIT_WATTS_PER_SQ_METER"
	},
	{
		"label": "Cubic-meters/min  (m³/min)",
		"value": "m³/min",
		"bacnet_unit": "UNIT_CUBIC_METERS_PER_MINUTE"
	},
	{
		"label": "Kiloamp-Hours  (kAH)",
		"value": "kAH",
		"bacnet_unit": null
	},
	{
		"label": "Cubic-meter/hour  (m³/h)",
		"value": "m³/h",
		"bacnet_unit": "UNIT_CUBIC_METERS_PER_HOUR"
	},
	{
		"label": "Kilowatt-Hour  (kWH)",
		"value": "kWH",
		"bacnet_unit": "UNIT_KILOWATT_HOURS"
	},
	{
		"label": "Kilohms (kΩ)",
		"value": "kΩ",
		"bacnet_unit": "UNIT_KILOHMS"
	},
	{
		"label": "Gallons/hour  (gal/hr)",
		"value": "gal/hr",
		"bacnet_unit": "UNIT_US_GALLONS_PER_HOUR"
	},
	{
		"label": "Newton (N)",
		"value": "N",
		"bacnet_unit": "UNIT_NEWTON"
	},
	{
		"label": "Candelas (cd)",
		"value": "cd",
		"bacnet_unit": "UNIT_CANDELAS"
	},
	{
		"label": "Megawatt  (MW)",
		"value": "MW",
		"bacnet_unit": "UNIT_MEGAWATTS"
	},
	{
		"label": "Tons Per Hour (ton/h)",
		"value": "ton/h",
		"bacnet_unit": "UNIT_TONS_PER_HOUR"
	},
	{
		"label": "Milligrams Per Gram (mg/g)",
		"value": "mg/g",
		"bacnet_unit": "UNIT_MILLIGRAMS_PER_GRAM"
	},
	{
		"label": "Feet Per Second (ft/s)",
		"value": "ft/s",
		"bacnet_unit": "UNIT_FEET_PER_SECOND"
	},
	{
		"label": "Sq Inches (in²)",
		"value": "in²",
		"bacnet_unit": "UNIT_SQ_INCHES"
	},
	{
		"label": "Decibels A (dB A)",
		"value": "dB A",
		"bacnet_unit": "UNIT_DECIBELS_A"
	},
	{
		"label": "Henrys (H)",
		"value": "H",
		"bacnet_unit": "UNIT_HENRYS"
	},
	{
		"label": "Milligrams Per Cubic Meter (mg/m³)",
		"value": "mg/m³",
		"bacnet_unit": "UNIT_MILLIGRAMS_PER_CUBIC_METER"
	},
	{
		"label": "Atmosphere  (atm)",
		"value": "atm",
		"bacnet_unit": null
	},
	{
		"label": "Us Gallons (gal)",
		"value": "gal",
		"bacnet_unit": "UNIT_US_GALLONS"
	},
	{
		"label": "Per Mille (/mi)",
		"value": "/mi",
		"bacnet_unit": "UNIT_PER_MILLE"
	},
	{
		"label": "Megajoules (MJ)",
		"value": "MJ",
		"bacnet_unit": "UNIT_MEGAJOULES"
	},
	{
		"label": "Per Hour (/h)",
		"value": "/h",
		"bacnet_unit": "UNIT_PER_HOUR"
	},
	{
		"label": "Degree Angular  (Deg)",
		"value": "Deg",
		"bacnet_unit": "UNIT_DEGREES_ANGULAR"
	},
	{
		"label": "Ampère per Square Meters (A/m²)",
		"value": "A/m²",
		"bacnet_unit": "UNIT_AMPERES_PER_SQUARE_METER"
	},
	{
		"label": "Liters/hour  (l/h)",
		"value": "l/h",
		"bacnet_unit": "UNIT_LITERS_PER_HOUR"
	},
	{
		"label": "Sq Feet (ft²)",
		"value": "ft²",
		"bacnet_unit": "UNIT_SQ_FEET"
	},
	{
		"label": "Years (years)",
		"value": "years",
		"bacnet_unit": "UNIT_YEARS"
	},
	{
		"label": "Temperature in Celsius  (°C)",
		"value": "°C",
		"bacnet_unit": "UNIT_DEGREES_C"
	},
	{
		"label": "Per Second (/s)",
		"value": "/s",
		"bacnet_unit": "UNIT_PER_SECOND"
	},
	{
		"label": "Watts Per Sq Foot (W/ft²)",
		"value": "W/ft²",
		"bacnet_unit": "UNIT_WATTS_PER_SQ_FOOT"
	},
	{
		"label": "Grams Per Square Meter (g/m²)",
		"value": "g/m²",
		"bacnet_unit": "UNIT_GRAMS_PER_SQUARE_METER"
	},
	{
		"label": "Joules (J)",
		"value": "J",
		"bacnet_unit": "UNIT_JOULES"
	},
	{
		"label": "Grams Per Kilogram (g/kg)",
		"value": "g/kg",
		"bacnet_unit": "UNIT_GRAMS_PER_KILOGRAM"
	},
	{
		"label": "Sieverts (Sv)",
		"value": "Sv",
		"bacnet_unit": "UNIT_SIEVERTS"
	},
	{
		"label": "Cubic-meter  (m³)",
		"value": "m³",
		"bacnet_unit": "UNIT_CUBIC_METERS"
	},
	{
		"label": "Decibar  (decibar)",
		"value": "decibar",
		"bacnet_unit": null
	},
	{
		"label": "Gray (Gy)",
		"value": "Gy",
		"bacnet_unit": "UNIT_GRAY"
	},
	{
		"label": "Power Factor (PF)",
		"value": "PF",
		"bacnet_unit": "UNIT_POWER_FACTOR"
	},
	{
		"label": "Ampere-Hours  (AH)",
		"value": "AH",
		"bacnet_unit": null
	},
	{
		"label": "Degrees Kelvin Per Hour (K/hour)",
		"value": "K/hour",
		"bacnet_unit": "UNIT_DEGREES_KELVIN_PER_HOUR"
	},
	{
		"label": "Volts Per Meter (V/m)",
		"value": "V/m",
		"bacnet_unit": "UNIT_VOLTS_PER_METER"
	},
	{
		"label": "GausS PER SECOND (Gy/s)",
		"value": "Gy/s",
		"bacnet_unit": "UNIT_GS_PER_SECOND"
	},
	{
		"label": "Months (months)",
		"value": "months",
		"bacnet_unit": "UNIT_MONTHS"
	},
	{
		"label": "Foot Candles (fc)",
		"value": "fc",
		"bacnet_unit": "UNIT_FOOT_CANDLES"
	},
	{
		"label": "Lbs Mass Per Minute (lb/min)",
		"value": "lb/min",
		"bacnet_unit": "UNIT_LBS_MASS_PER_MINUTE"
	},
	{
		"label": "Kilowatt Hours Reactive (kW/hR)",
		"value": "kW/hR",
		"bacnet_unit": "UNIT_KILOWATT_HOURS_REACTIVE"
	},
	{
		"label": "Grams Per Cubic Meter (g/m³)",
		"value": "g/m³",
		"bacnet_unit": "UNIT_GRAMS_PER_CUBIC_METER"
	},
	{
		"label": "Decibels Volt (dBV)",
		"value": "dBV",
		"bacnet_unit": "UNIT_DECIBELS_VOLT"
	},
	{
		"label": "GaUSS PER MINUTE (Gy/min)",
		"value": "Gy/min",
		"bacnet_unit": "UNIT_GS_PER_MINUTE"
	},
	{
		"label": "Kilohertz (kHz)",
		"value": "kHz",
		"bacnet_unit": "UNIT_KILOHERTZ"
	},
	{
		"label": "Kilowatt  (kW)",
		"value": "kW",
		"bacnet_unit": "UNIT_KILOWATTS"
	},
	{
		"label": "Nanograms Per Cubic Meter (ng/m³)",
		"value": "ng/m³",
		"bacnet_unit": "UNIT_NANOGRAMS_PER_CUBIC_METER"
	},
	{
		"label": "Watts Per Meter Per Degree Kelvin (W/m/K)",
		"value": "W/m/K",
		"bacnet_unit": "UNIT_WATTS_PER_METER_PER_DEGREE_KELVIN"
	},
	{
		"label": "Cubic-meters/sec  (m³/sec)",
		"value": "m³/sec",
		"bacnet_unit": "UNIT_CUBIC_METERS_PER_SECOND"
	},
	{
		"label": "Cycles Per Hour (cycles/hour)",
		"value": "cycles/hour",
		"bacnet_unit": "UNIT_CYCLES_PER_HOUR"
	},
	{
		"label": "Kilopounds  (klbs)",
		"value": "klbs",
		"bacnet_unit": null
	},
	{
		"label": "Joules Per Degree K (J/K)",
		"value": "J/K",
		"bacnet_unit": "UNIT_JOULES_PER_DEGREE_K"
	},
	{
		"label": "Milligrams (mg)",
		"value": "mg",
		"bacnet_unit": "UNIT_MILLIGRAMS"
	}
]